import { BaseCall } from '../BaseCall'
import * as qs from 'query-string'
import { APIConfig } from '../interfaces'

export interface VersionChange {
	changeType: string
	description: string
}

export interface Version {
	changes: VersionChange[]
	versionDate: string
	versionNumber: string
	versionType: string
}

export interface ChangeLogs {
	versions: Version[]
	productName: string
	title: string
}

export class Logs extends BaseCall {
	// Logs Routes

	public getServerLogs = (): Promise<string> => this.client.get('/view/dev/logs').then((response) => response.data)

	public getRegionChangeLog = (): Promise<any> => this.client.get('/userdata/region-change-log').then((response) => response.data)
	public getChangeLogs = async (product: string, environment: string, os: string): Promise<ChangeLogs | undefined> => {
		try {
			const changeLogsResponse = await this.client.get<ChangeLogs>(`/view/change-logs/${product}/${environment}/${os}`, {
				withCredentials: true
			})

			return changeLogsResponse.data
		} catch (e) {
			// console.log(e)
		}
	}

	public getUserData = (params: any): Promise<any> => this.client
			.get(`/userdata/users`, {
				params: params
			})
			.then((response) => response.data)

	public getRegistrationsData = async (params: any): Promise<any> => {
		const res = await this.client.get(`/userdata/registrations`, { params: params })

		return res.data
	}

	getKeys = async (submissionData: any): Promise<void> => {
		const query = qs.stringify(submissionData)
		return this.client
			.get(`/api-v2/dev/codes?${ query}`, {
				responseType: 'blob',
				withCredentials: true
			})
			.then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]))
				const link = document.createElement('a')
				link.href = url
				link.setAttribute('download', 'keys.csv')
				document.body.appendChild(link)
				link.click()
			})
	}

	public setConfig(config: APIConfig): void {
		this.setBaseUrl(config.API_SERVER)
	}
}
